export default __webpack_public_path__ + "static/media/b34.e4ec025c.png";